import React, { useState, useEffect, useContext } from "react";
import { Switch, Route, useHistory } from "react-router-dom";
import {
  AdminMenuItems,
  EnrolleeMenuItems,
  MarketingMenuItems,
  StudentAffairsMenuItems,
  IdCardMenuItems,
} from "./SideBarData";
import EnrolleeList from "./secretary/EnrolleeList";
import SingleEnrolleePage from "./secretary/SingleEnrolleePage";
import UserProfile from "./UserProfile";
import clsx from "clsx";
import {
  AppBar,
  Toolbar,
  Typography,
  CssBaseline,
  makeStyles,
  IconButton,
  Badge,
  Avatar,
  Drawer,
  Divider,
  List,
  Container,
  Menu,
  MenuItem,
  Button,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import AuthenticatedContent from "../common/AuthenticatedContent";
import ExamRegistration from "./ExamRegistration";
import { MoreHoriz } from "@material-ui/icons";
import EducationInfo from "./EducationInfo";
import IdentityDocs from "./IdentityDocs";
import ProfileSettings from "./ProfileSettings";
import CreateUsers from "./admin/CreateUsers";
import DormAccomodation from "./student-affairs/DormAccomodation";
import DormApplications from "./student-affairs/DormApplications";
import ServicesContext from "../contexts/servicesContext";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Aet from "./Aet";
import AetRequestList from "./marketing/AetRequestList";
import AetRegionList from "./marketing/aetRegion/AetRegionList";
import AetDateList from "./marketing/aetDate/AetDateList";
import AetResultList from "./marketing/AetResultList";
import AchievementInfo from "./abit/AchievementInfo";
import AetPoints from "./secretary/AetPoints";
import ContractPage from "./abit/ContractPage";
import CustomCard from "./cards/CustomCard";
import IdCard from "./cards/IdCard";
import DormContract from "./student-affairs/DormContract";
// import PersonalInfo from "./abit/PersonalInfo";
// import Documents from "./abit/Documents";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 2,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    height: "100vh",
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}));

function Dashboard() {
  const classes = useStyles();

  const [anchorElement, setAnchorElement] = useState(null);
  const [open, setOpen] = useState(true);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [applicationDeadlineHasNotPassed, setApplicationDeadlineHasNotPassed] =
    useState(false);
  const [isContractReady, setIsContractReady] = useState(false);
  const [isCanApplyDormContract, setIsCanApplyDormContract] = useState(false);

  const history = useHistory();
  const services = useContext(ServicesContext);

  const [year, setYear] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);

  useEffect(() => {
    const userId = services.auth.getCurrentUser().id;

    services.secretary
      .checkConfirm(userId)
      .then((response) => setIsConfirmed(response.data))

    services.contract
      .checkContract()
      .then((response) => setIsContractReady(response.data))

    services.dormContract
      .canApply()
      .then((response) => setIsCanApplyDormContract(response.data))

    services.studentAffairs
      .checkApplicationDeadline()
      .then((response) => setApplicationDeadlineHasNotPassed(response.data))
    if (
      localStorage.getItem("AdmissionOfYear") !== null &&
      localStorage.getItem("AdmissionOfYear") !== undefined
    ) {
      setYear(localStorage.getItem("AdmissionOfYear"));
    } else {
      localStorage.setItem("AdmissionOfYear", 2026);
      setYear(localStorage.getItem("AdmissionOfYear"));
    }
  }, [services]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    setAnchorElement(null);
    services.auth.logout();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChangeYear = (event) => {
    setYear(event.target.value);
    localStorage.setItem("AdmissionOfYear", event.target.value);
    setAnchorEl(null);
  };

  const selectApplicationYear = () => {
    return (
      <>
        <Button
          variant="contained"
          aria-label="split button"
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          Application year ({year})
          <ArrowDropDownIcon />
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleChangeYear}
          sx={{ minWidth: 220 }}
        >
          <MenuItem onClick={handleChangeYear} value="2022">
            2022
          </MenuItem>
          <MenuItem onClick={handleChangeYear} value="2023">
            2023
          </MenuItem>
          <MenuItem onClick={handleChangeYear} value="2024">
            2024
          </MenuItem>
          <MenuItem onClick={handleChangeYear} value="2025">
            2025
          </MenuItem>
          <MenuItem onClick={handleChangeYear} value="2026">
            2026
          </MenuItem>
        </Menu>
      </>
    );
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="absolute"
        className={clsx(classes.appBar, open && classes.appBarShift)}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(
              classes.menuButton,
              open && classes.menuButtonHidden
            )}
          >
            <MenuIcon />
          </IconButton>

          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            AITU Enrollment
          </Typography>
          <AuthenticatedContent role={"ROLE_SECRETARY"}>
            {selectApplicationYear()}
          </AuthenticatedContent>
          <AuthenticatedContent role={"ROLE_STUDENT"}>
            {selectApplicationYear()}
          </AuthenticatedContent>
          <AuthenticatedContent role={"ROLE_DORMITORY"}>
            {selectApplicationYear()}
          </AuthenticatedContent>
          <AuthenticatedContent role={"ROLE_MARKETING"}>
            {selectApplicationYear()}
          </AuthenticatedContent>

          <IconButton color="inherit">
            <Badge badgeContent={0} color="secondary">
              <Avatar />
            </Badge>
          </IconButton>

          <IconButton
            color="inherit"
            onClick={(event) => setAnchorElement(event.currentTarget)}
          >
            <MoreHoriz />
          </IconButton>

          <Menu
            id="simple-menu"
            anchorEl={anchorElement}
            keepMounted
            open={Boolean(anchorElement)}
            onClose={() => setAnchorElement(null)}
          >
            <MenuItem
              onClick={() => {
                setAnchorElement(null);
                history.push("/profile-settings");
              }}
            >
              Профиль
            </MenuItem>
            <MenuItem onClick={handleLogout}>Выйти</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeft />
          </IconButton>
        </div>
        <Divider />
        <List>
          <AuthenticatedContent role={"ROLE_USER"}>
            <EnrolleeMenuItems
              canApplyToDorm={applicationDeadlineHasNotPassed}
              canSignContract={isContractReady}
              canApplyDormContract={isCanApplyDormContract}
            />
          </AuthenticatedContent>
          <AuthenticatedContent role={"ROLE_SECRETARY"}>
            <AdminMenuItems />
          </AuthenticatedContent>
          <AuthenticatedContent role={"ROLE_STUDENT"}>
            <AdminMenuItems />
          </AuthenticatedContent>
          <AuthenticatedContent role={"ROLE_DORMITORY"}>
            <StudentAffairsMenuItems />
          </AuthenticatedContent>
          <AuthenticatedContent role={"ROLE_MARKETING"}>
            <MarketingMenuItems />
          </AuthenticatedContent>
          <AuthenticatedContent role={"ROLE_ID_CARD"}>
            <IdCardMenuItems />
          </AuthenticatedContent>
        </List>
      </Drawer>

      <main className={classes.content}>
        <div className={classes.appBarSpacer}></div>
        <Container maxWidth="xl" className={classes.container}>
          <AuthenticatedContent role={"ROLE_USER"}>
            <Switch>
              <Route exact path="/" component={UserProfile} />
              <Route path="/docs" component={IdentityDocs} />
              <Route path="/exam-registration" component={ExamRegistration} />
              <Route path="/education-info" component={EducationInfo} />
              <Route path="/achievements" component={AchievementInfo} />
              <Route path="/aet" component={Aet} />
              {applicationDeadlineHasNotPassed && (
                <Route
                  path="/dormitory-accomodation"
                  component={DormAccomodation}
                />
              )}
              {isContractReady && (
                <Route path="/contract" component={ContractPage} />
              )}
              <Route path="/profile-settings" component={ProfileSettings} />
              <Route path="/dorm-contract" component={DormContract} />
            </Switch>
          </AuthenticatedContent>
          <AuthenticatedContent role={"ROLE_SECRETARY"}>
            <Switch>
              <Route exact path="/enrollees" component={EnrolleeList} />
              <Route
                exact
                path="/confirmed-enrollees"
                render={() => <EnrolleeList showOnlyConfirmed />}
              />
              <Route
                path="/enrollees/:id"
                render={({ match }) => (
                  <SingleEnrolleePage id={match.params.id} />
                )}
              />
              <Route
                path="/aet-points"
                component={AetPoints}
              />
              <Route path="/profile-settings" component={ProfileSettings} />
            </Switch>
          </AuthenticatedContent>
          <AuthenticatedContent role={"ROLE_STUDENT"}>
            <Switch>
              <Route exact path="/enrollees" component={EnrolleeList} />
              <Route
                exact
                path="/confirmed-enrollees"
                render={() => <EnrolleeList showOnlyConfirmed />}
              />
              <Route
                path="/enrollees/:id"
                render={({ match }) => (
                  <SingleEnrolleePage id={match.params.id} />
                )}
              />
              <Route path="/profile-settings" component={ProfileSettings} />
            </Switch>
          </AuthenticatedContent>
          <AuthenticatedContent role={"ROLE_ADMIN"}>
            <Switch>
              <Route exact path="/" component={CreateUsers} />
              <Route path="/profile-settings" component={ProfileSettings} />
            </Switch>
          </AuthenticatedContent>
          <AuthenticatedContent role={"ROLE_DORMITORY"}>
            <Switch>
              <Route
                exact
                path="/dorm-applications-first-stage"
                render={() => <DormApplications isFirstStage />}
              />
              <Route
                path="/enrollees/:id"
                render={({ match }) => (
                  <SingleEnrolleePage id={match.params.id} />
                )}
              />
              <Route
                exact
                path="/dorm-applications-second-stage"
                render={() => <DormApplications isSecondStage />}
              />
              <Route
                exact
                path="/dorm-accepted-applications"
                render={() => <DormApplications isAcceptedApplicationsStage />}
              />
              <Route
                exact
                path="/dorm-declined-applications"
                render={() => <DormApplications isDeclinedApplicationsStage />}
              />
              <Route path="/profile-settings" component={ProfileSettings} />
            </Switch>
          </AuthenticatedContent>
          <AuthenticatedContent role={"ROLE_MARKETING"}>
            <Switch>
              <Route exact path="/" component={AetRequestList} />
              <Route path="/profile-settings" component={ProfileSettings} />
              <Route exact path="/aet-requests" component={AetRequestList} />
              <Route exact path="/aet-results" component={AetResultList} />
              <Route exact path="/aet-regions" component={AetRegionList} />
              <Route exact path="/aet-exams" component={AetDateList} />
              <Route
                path="/aet-points"
                component={AetPoints}
              />
            </Switch>
          </AuthenticatedContent>
          <AuthenticatedContent role={"ROLE_ID_CARD"}>
            <Switch>
              <Route exact path="/" component={IdCard} />
              <Route path="/id-cards" component={IdCard} />
              <Route path="/custom-card" component={CustomCard} />

            </Switch>
          </AuthenticatedContent>
        </Container>
      </main>
    </div>
  );
}

export default Dashboard;
